/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconEmpty = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-empty',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.503 22h-2.5v-2.5h1.875a.627.627 0 0 0 .625-.625v-1.88H22V19.5c0 1.378-1.12 2.5-2.497 2.5Zm0-12.5H22v4.998h-2.497V9.5Zm0-4.375a.624.624 0 0 0-.625-.625h-1.875V2h2.5A2.499 2.499 0 0 1 22 4.5V7h-2.497V5.125ZM9.498 4.5V2h5v2.5h-5Zm-4.373 0a.622.622 0 0 0-.625.625V7H2V4.5A2.5 2.5 0 0 1 4.5 2H7v2.5H5.125ZM4.5 14.498H2V9.5h2.5v4.998Zm0 4.377c0 .343.277.625.625.625H7V22H4.5C3.12 22 2 20.878 2 19.5v-2.505h2.5v1.88Zm9.998.625V22h-5v-2.5h5Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconEmpty.displayName = 'IconEmpty';
export default IconEmpty;
